export default {
  root: {
    minHeight: 45,
    '&$expanded': {
      minHeight: 45,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
};
